import C from "@/components/forms/WSearchField.module.css";

import { useDebounceInput } from "@/components/forms/useDebounceInput.tsx";
import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { mcn } from "@/utils/baseProps.ts";
import { cn } from "@/utils/classNames.ts";
import type { SearchFieldProps } from "react-aria-components";
import { Button, Input, SearchField } from "react-aria-components";

interface WSearchFieldProps extends Omit<SearchFieldProps, "className"> {
    className?: string;
    width?: string;
    minimumLength?: number;
}

export function WSearchField({
    width,
    value,
    defaultValue,
    onChange,
    onBlur,
    minimumLength = 3,
    ...props
}: WSearchFieldProps) {
    function validatedOnChange(value: string) {
        // Empty string is valid
        if (value.length < minimumLength && value.length > 0) {
            return;
        }

        onChange?.(value);
    }

    const inputProps = useDebounceInput({ onChange: validatedOnChange, value, defaultValue, onBlur });

    return (
        <SearchField aria-label="Search query" {...inputProps} {...mcn(cn(C.SearchField, width ?? "w-full"), props)}>
            {({ isEmpty }) => (
                <>
                    {isEmpty && <MaskIcon className={cn(C.Icon, "jp-icon-search size-0.875rem text-muted")} />}
                    <Input className={C.Input} />
                    <Button className={C.Button}>✕</Button>
                </>
            )}
        </SearchField>
    );
}
